// Club header menu. The trigger stays a real link: hover or a first tap opens the panel,
// a click or a second tap goes to the category.
(function () {
  var nav = document.querySelector('[data-clubnav]');
  if (!nav) return;

  var HANDLE = /^[a-z0-9-]+$/;
  var CLOSE_DELAY = 180;

  (function markCurrent() {
    var storePath = (nav.getAttribute('data-store-path') || '').replace(/\/$/, '');
    // On a club's own address (mmfc.sannicosports.com) the store page is also served at "/".
    var here = window.location.pathname.replace(/\/$/, '');
    if (!storePath || (here !== storePath && here !== '')) return;
    var params;
    try {
      params = new URLSearchParams(window.location.search);
    } catch (e) {
      return;
    }
    var cat = params.get('category');
    var sub = params.get('subcategory');
    if (cat && !HANDLE.test(cat)) cat = null;
    if (sub && !HANDLE.test(sub)) sub = null;

    if (!cat && !sub) {
      var home = nav.querySelector('[data-clubnav-home]');
      if (home) {
        home.classList.add('is-current');
        home.setAttribute('aria-current', 'page');
      }
      return;
    }
    nav.querySelectorAll('[data-clubnav-cat]').forEach(function (el) {
      var subs = (el.getAttribute('data-clubnav-subs') || '').split(' ');
      if ((cat && el.getAttribute('data-clubnav-cat') === cat) || (sub && subs.indexOf(sub) > -1)) {
        el.classList.add('is-current');
      }
    });
    if (sub) {
      nav.querySelectorAll('[data-clubnav-sub="' + sub + '"]').forEach(function (el) {
        el.classList.add('is-current');
        el.setAttribute('aria-current', 'page');
      });
    }
  })();

  var track = nav.querySelector('[data-clubnav-track]');
  function markMore() {
    if (!track) return;
    nav.classList.toggle('has-more', track.scrollLeft + track.clientWidth < track.scrollWidth - 4);
  }
  if (track) {
    var current = track.querySelector('.snc-clubhd__link.is-current');
    if (current) {
      var cRect = current.getBoundingClientRect();
      var tkRect = track.getBoundingClientRect();
      if (cRect.right > tkRect.right || cRect.left < tkRect.left) {
        track.scrollLeft += cRect.left - tkRect.left - 5;
      }
    }
    markMore();
    track.addEventListener('scroll', markMore, { passive: true });
    window.addEventListener('resize', markMore);
  }

  var menus = [].slice.call(nav.querySelectorAll('[data-clubmenu]'));
  if (!menus.length) return;

  var openMenu = null;
  var closeTimer = null;
  // Set while Escape hands focus back to the trigger, so that focus doesn't reopen it.
  var returningFocus = false;

  function trigger(menu) { return menu.querySelector('[data-clubmenu-trigger]'); }
  function panel(menu) { return menu.querySelector('[data-clubmenu-panel]'); }

  // Fixed position from the trigger's box, clamped to the screen, so one path works at every width.
  var EDGE_MARGIN = 16;
  function positionPanel(menu) {
    var t = trigger(menu);
    var p = panel(menu);
    if (!t || !p) return;
    var tRect = t.getBoundingClientRect();
    var pWidth = p.offsetWidth;
    var left = tRect.left - 5;
    var maxLeft = window.innerWidth - pWidth - EDGE_MARGIN;
    if (left > maxLeft) left = maxLeft;
    if (left < EDGE_MARGIN) left = EDGE_MARGIN;
    p.style.top = tRect.bottom + 16 + 'px';
    p.style.left = left + 'px';
    // A fixed panel does not scroll, so cap it to the room under the bar and let the grid scroll.
    p.style.setProperty('--mega-max', Math.max(200, window.innerHeight - (tRect.bottom + 16) - EDGE_MARGIN) + 'px');
  }

  function open(menu) {
    clearTimeout(closeTimer);
    if (openMenu && openMenu !== menu) close(openMenu);
    positionPanel(menu);
    menu.classList.add('is-open');
    trigger(menu).setAttribute('aria-expanded', 'true');
    openMenu = menu;
  }

  function close(menu) {
    menu.classList.remove('is-open');
    trigger(menu).setAttribute('aria-expanded', 'false');
    if (openMenu === menu) openMenu = null;
  }

  function isKeyboardFocus(el) {
    try {
      return el.matches(':focus-visible');
    } catch (e) {
      return false;
    }
  }

  menus.forEach(function (menu) {
    var t = trigger(menu);

    menu.addEventListener('pointerenter', function (e) {
      if (e.pointerType === 'mouse') open(menu);
    });
    menu.addEventListener('pointerleave', function (e) {
      if (e.pointerType !== 'mouse') return;
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function () { close(menu); }, CLOSE_DELAY);
    });

    t.addEventListener('click', function (e) {
      if (!menu.classList.contains('is-open')) {
        e.preventDefault();
        open(menu);
      }
    });

    // Keyboard only: a tap also focuses the trigger, and opening on focus would make the first tap navigate.
    menu.addEventListener('focusin', function (e) {
      if (e.target === t && !returningFocus && isKeyboardFocus(t)) open(menu);
    });
    menu.addEventListener('focusout', function (e) {
      if (!menu.contains(e.relatedTarget)) close(menu);
    });
  });

  document.addEventListener('click', function (e) {
    if (openMenu && !openMenu.contains(e.target)) close(openMenu);
  });

  if (track) {
    track.addEventListener('scroll', function () { if (openMenu) close(openMenu); }, { passive: true });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || !openMenu) return;
    var t = trigger(openMenu);
    close(openMenu);
    returningFocus = true;
    t.focus();
    returningFocus = false;
  });
})();
